import React, {Fragment, cloneElement} from "react";
import { 
    List,
    useListContext,
    sanitizeListRestProps,
    Datagrid, 
    TextField,
    Show,
    SimpleShowLayout,
    Create,
    Edit,
    SimpleForm, 
    TextInput,
    Filter,
    BulkDeleteButton,
    Toolbar,
    TopToolbar,
    CreateButton,
    SaveButton,
    DeleteButton,
    ShowButton,
    EditButton,
    CloneButton,
    required,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const SchoolListActions = (props) => {
  const {
    className,
    exporter,
    filters,
    maxResults,
    ...rest
  } = props;
  const {
    resource,
    displayedFilters,
    filterValues,
    basePath,
    showFilter,
  } = useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters && cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
      <CreateButton basePath={basePath} label="新增"/>
    </TopToolbar>
  );
};

const SchoolBulkActionButtons = props => (
  <Fragment>
    <BulkDeleteButton undoable = {false} {...props} />
  </Fragment>
);

const SchoolFilter = (props) => (
  <Filter {...props}>
  </Filter>
);

const SchoolEditToolbar = props => (
  <Toolbar {...props} classes={useStyles()}>
    <SaveButton  label="儲存"/>
    <DeleteButton label="刪除" undoable = {false} />
  </Toolbar>
);

const SchoolForm = (props) => (
  <SimpleForm {...props}>
    <TextInput 
      source="name"
      label="名稱"
      validate={required()}
      fullWidth
    />
    <TextInput 
      source="abbreviation"
      label="簡稱"
      validate={required()}
      fullWidth
    /> 
  </SimpleForm>
)

export const SchoolList = (props) => (
  <List {...props} 
    filters={<SchoolFilter />}
    actions={<SchoolListActions/>}
    bulkActionButtons={<SchoolBulkActionButtons />}
  >
    <Datagrid>
      <TextField source="name" label="名稱"/>
      <TextField source="abbreviation" label="簡稱"/>
      <ShowButton label="詳情"/>
      <EditButton label="編輯"/>
      <CloneButton label="複製"/>
    </Datagrid>
  </List>
);

export const SchoolShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="name" label="名稱"/>
      <TextField source="abbreviation" label="簡稱"/>
    </SimpleShowLayout>
  </Show>
);

export const SchoolCreate = (props) => (
  <Create {...props}>
    <SchoolForm />
  </Create>
);

export const SchoolEdit = (props) => (
  <Edit {...props} undoable = {false} >
    <SchoolForm toolbar={<SchoolEditToolbar />} />
  </Edit>
);